module.exports = __webpack_public_path__ + "img/Fs_Ui_Info_Star_01.05b2fed5.png";